/** The Classic set: 1984's elements, 16 caves and 4 intermissions in letter order (docs/spec/03 §2). */

import type { CaveSet } from '../types';
import { caveA } from './a';
import { caveB } from './b';
import { caveC } from './c';
import { caveD } from './d';
import { caveE } from './e';
import { caveF } from './f';
import { caveG } from './g';
import { caveH } from './h';
import { caveI } from './i';
import { caveJ } from './j';
import { caveK } from './k';
import { caveL } from './l';
import { caveM } from './m';
import { caveN } from './n';
import { caveO } from './o';
import { caveP } from './p';
import { caveQ } from './q';
import { caveR } from './r';
import { caveS } from './s';
import { caveT } from './t';

export const CLASSIC: CaveSet = {
  id: 'classic',
  name: 'CLASSIC',
  caves: [
    caveA, caveB, caveC, caveD, caveE, caveF, caveG, caveH, caveI, caveJ,
    caveK, caveL, caveM, caveN, caveO, caveP, caveQ, caveR, caveS, caveT,
  ],
};
